import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.CENTRIFUGE)
export default class Centrifuge extends BaseModel {
  @StringField()
  public id: string
}
